module.exports = __webpack_public_path__ + "static/media/project4.c450d909.jpg";